export class UserAgentSetting {
  idUserAgentSetting: number;
  idUserAgent: number;
  idAgentSetting: number;
  value: string;

  constructor(
    idUserAgentSetting: number,
    idUserAgent: number,
    idAgentSetting: number,
    value: string,
  ) {
    this.idUserAgentSetting = idUserAgentSetting;
    this.idUserAgent = idUserAgent;
    this.idAgentSetting = idAgentSetting;
    this.value = value;
  }

  static fromRaw(raw: any): UserAgentSetting {
    return new UserAgentSetting(
      Number(raw.idUserAgentSetting),
      Number(raw.idUserAgent),
      Number(raw.idAgentSetting),
      String(raw.value),
    );
  }

  clone(): UserAgentSetting {
    return new UserAgentSetting(
      this.idUserAgentSetting,
      this.idUserAgent,
      this.idAgentSetting,
      this.value,
    );
  }

  toPayload(): any {
    return {
      idUserAgentSetting: this.idUserAgentSetting,
      idUserAgent: this.idUserAgent,
      idAgentSetting: this.idAgentSetting,
      value: this.value,
    };
  }
}
